module.exports = function () {
    return {
        restrict: 'E',
        transclude: true,
        link(scope, element, iAttrs, controller, transcludeFn) {
            transcludeFn((clone) => {
                element.append(clone);
            });

            element.find('label').addClass('olySelect-label');
            element.find('select').addClass('olySelect-select');
        },
        template: '<i class="olySelect-icon iconww-ArrowDown"></i>',
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/select/select.directive.js